import config from '../../config';
import executeApiAsync from '../../services/utils/executeApiAsync';
import { Option } from '../../components/SelectFilter/SelectFilter';
import { IEmployee } from '@ready/employee.core';
import { IPagedResponse } from '@ready/table.core';
import { convertEmployeeToOption, convertPosItemToOption, PosItem } from 'utils/mappers/toOption';

export default class LocationPOSService {
  private static readonly BASE_URL = `${config.readyApiLegacyEndpoint}/admins/locations/`;

  public static getPOSLocations = async (
    locationId: string,
    serviceType?: string
  ): Promise<[{ id: string; name: string }]> => {
    const serviceTypeQuery = serviceType ? `?serviceType=${serviceType}` : '';
    return executeApiAsync<[{ id: string; name: string }]>(
      LocationPOSService.BASE_URL + `${locationId}/posLocations${serviceTypeQuery}`
    );
  };

  public static getTenderTypes = async (locationId: string, params?: Record<string, string>): Promise<Option[]> => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    const tenderTypes = await executeApiAsync<PosItem[]>(
      `${config.readyApiLegacyEndpoint}/admins/locations/${locationId}/tenderTypes${queryString}`
    );

    return tenderTypes.map(convertPosItemToOption);
  };

  public static getSimphonyLocations = async (locationId: string, params?: Record<string, string>): Promise<Option[]> => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    const locations = await executeApiAsync<{ id: string; name: string }[]>(
      `${config.readyApiLegacyEndpoint}/admins/locations/${locationId}/posLocations${queryString}`
    );

    return locations.map((l) => ({ label: l.name, value: l.id }));
  };

  public static getSimphonyRevenueCenters = async (locationId: string, params?: Record<string, string>): Promise<Option[]> => {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    const revenueCenters = await executeApiAsync<{ id: string; name: string }[]>(
      `${config.readyApiLegacyEndpoint}/admins/locations/${locationId}/revenueCenters${queryString}`
    );

    return revenueCenters.map((rc) => ({ label: rc.name, value: rc.id }));
  };

  static getEmployees = async (companyId: string, locationId: string, filter: string): Promise<Option[]> => {
    const response = await executeApiAsync<IPagedResponse<IEmployee>>(
      `${config.readyDashboardApiEndpoint}/companies/${companyId}/locations/${locationId}/employees?q=${filter}&page=1&size=50`
    );

    return response.results.map(convertEmployeeToOption);
  };
}
